module.exports = __webpack_public_path__ + "static/gear-5c8f6c264a109fe38296da066a60defa.gif";